import { render } from "./Main.vue?vue&type=template&id=f495bff2&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=f495bff2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f495bff2"

export default script